<template>
  <div class="request-popup-container">
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="createRequestStep==='main'"
        key="main"
        class="list-group list-group-flush"
      >
        <a
          class="list-group-item d-flex justify-content-between align-items-center cursor-enabled"
          @click="createRequestStep='info'"
        >
          <div class="d-flex align-items-center">
            <div class="icon-container">
              <img
                src="@/assets/images/icons/request/info.png"
                class="request-icon"
                alt="request-icon"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.informasiyaSorusu') }}</span>
          </div>
          <div class="chevron-container">
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('LOG') || canCreate('RFQ'), 'cursor-disabled': !canCreate('LOG') && !canCreate('RFQ')}"
          @click="(canCreate('LOG') || canCreate('RFQ')) ? createRequestStep='price' : null"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('LOG') || canCreate('RFQ'),
                     'text-secondary': !canCreate('LOG') && !canCreate('RFQ')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('LOG') || canCreate('RFQ')"
                src="@/assets/images/icons/request/price.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.qiymtSorusu') }}</span>
          </div>
          <div class="chevron-container">
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('OFR'), 'cursor-disabled': !canCreate('OFR')}"
          @click="canCreate('OFR')?$router.push({name: 'newOFFER'}):showProfileRequiredModal('OFR')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('OFR'), 'text-secondary': !canCreate('OFR')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('OFR')"
                src="@/assets/images/icons/request/offer.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.tklifElan') }}</span>
          </div>
          <div
            v-if="canCreate('OFR')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('TRK'), 'cursor-disabled': !canCreate('TRK')}"
          @click="canCreate('TRK')?$router.push({name: 'newTRK'}):showProfileRequiredModal('TRK')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('TRK'), 'text-secondary': !canCreate('TRK')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('TRK')"
                src="@/assets/images/icons/request/truck.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.trElan') }}</span>
          </div>
          <div
            v-if="canCreate('TRK')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('TRS'), 'cursor-disabled': !canCreate('TRS')}"
          @click="canCreate('TRS')?$router.push({name: 'newTRS'}):showProfileRequiredModal('TRS')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('TRS'), 'text-secondary': !canCreate('TRS')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('TRS')"
                src="@/assets/images/icons/request/truck-search.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.trAxtar') }}</span>
          </div>
          <div
            v-if="canCreate('TRS')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('AUC'), 'cursor-disabled': !canCreate('AUC')}"
          @click="canCreate('AUC')?$router.push({name: 'newAUC'}):showProfileRequiredModal('AUC')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('AUC'), 'text-secondary': !canCreate('AUC')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('AUC')"
                src="@/assets/images/icons/request/auction.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.auksion') }}</span>
          </div>
          <div
            v-if="canCreate('AUC')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('REV'), 'cursor-disabled': !canCreate('REV')}"
          @click="canCreate('REV')?$router.push({name: 'newREV'}):showProfileRequiredModal('REV')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('REV'), 'text-secondary': !canCreate('REV')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('REV')"
                src="@/assets/images/icons/request/auction-reverse.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.ksAuksion') }}</span>
          </div>
          <div
            v-if="canCreate('REV')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('POL'), 'cursor-disabled': !canCreate('POL')}"
          @click="canCreate('POL')?$router.push({name: 'newPOL'}):showProfileRequiredModal('POL')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('POL'), 'text-secondary': !canCreate('POL')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('POL')"
                src="@/assets/images/icons/request/poll.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.ssverm') }}</span>
          </div>
          <div
            v-if="canCreate('POL')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
      </div>
    </transition>

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="createRequestStep==='info'"
        key="info"
        class="list-group list-group-flush"
      >
        <a
          class="list-group-item d-flex align-items-center cursor-enabled"
          @click="createRequestStep='main'"
        >
          <feather
            type="chevron-left"
            size="20px"
          />
          {{ $t('newRequestPopupContent.informasiyaSorusu') }}
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('LGI'), 'cursor-disabled': !canCreate('LGI')}"
          @click="canCreate('LGI')?$router.push({name: 'newINFO', query: {type: 'LGI'}}):showProfileRequiredModal('LGI')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('LGI'), 'text-secondary': !canCreate('LGI')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('LGI')"
                src="@/assets/images/icons/request/info.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.logistikInformasiyaSorusu') }}</span>
          </div>
          <div
            v-if="canCreate('LGI')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('CSI'), 'cursor-disabled': !canCreate('CSI')}"
          @click="canCreate('CSI')?$router.push({name: 'newINFO', query: {type: 'CSI'}}):showProfileRequiredModal('CSI')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('CSI'), 'text-secondary': !canCreate('CSI')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('CSI')"
                src="@/assets/images/icons/request/info.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.gmrkInformasiyaSorusu') }}</span>
          </div>
          <div
            v-if="canCreate('CSI')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('WHI'), 'cursor-disabled': !canCreate('WHI')}"
          @click="canCreate('WHI')?$router.push({name: 'newINFO', query: {type: 'WHI'}}):showProfileRequiredModal('WHI')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('WHI'), 'text-secondary': !canCreate('WHI')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('WHI')"
                src="@/assets/images/icons/request/info.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.anbarInformasiyaSorusu') }}</span>
          </div>
          <div
            v-if="canCreate('WHI')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('RFI'), 'cursor-disabled': !canCreate('RFI')}"
          @click="canCreate('RFI')?$router.push({name: 'newINFO', query: {type: 'RFI'}}):showProfileRequiredModal('RFI')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('RFI'), 'text-secondary': !canCreate('RFI')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('RFI')"
                src="@/assets/images/icons/request/info.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.mumiInformasiyaSorusu') }}</span>
          </div>
          <div
            v-if="canCreate('RFI')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
      </div>
    </transition>

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="createRequestStep==='price'"
        key="price"
        class="list-group list-group-flush"
      >
        <a
          class="list-group-item d-flex align-items-center cursor-enabled"
          @click="createRequestStep='main'"
        >
          <feather
            type="chevron-left"
            size="20px"
          />
          {{ $t('newRequestPopupContent.qiymtSorusu') }}
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('LOG'), 'cursor-disabled': !canCreate('LOG')}"
          @click="canCreate('LOG')?$router.push({name: 'newLogistic'}):showProfileRequiredModal('LOG')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('LOG'), 'text-secondary': !canCreate('LOG')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('LOG')"
                src="@/assets/images/icons/request/price.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.logistikQiymtSorusu') }}</span>
          </div>
          <div
            v-if="canCreate('LOG')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
        <a
          class="list-group-item d-flex justify-content-between align-items-center"
          :class="{'cursor-enabled': canCreate('RFQ'), 'cursor-disabled': !canCreate('RFQ')}"
          @click="canCreate('RFQ')?$router.push({name: 'newPQ'}):showProfileRequiredModal('RFQ')"
        >
          <div
            class="d-flex align-items-center"
            :class="{'text-dark': canCreate('RFQ'), 'text-secondary': !canCreate('RFQ')}"
          >
            <div class="icon-container">
              <img
                v-if="canCreate('RFQ')"
                src="@/assets/images/icons/request/price.png"
                class="request-icon"
                alt="request-icon"
              >
              <img
                v-else
                src="@/assets/images/icons/lock.png"
                class="request-icon-disabled"
                alt="request-icon-disabled"
              >
            </div>
            <span>{{ $t('newRequestPopupContent.malVXidmtlrBalQiymtSorusu') }}</span>
          </div>
          <div
            v-if="canCreate('RFQ')"
            class="chevron-container"
          >
            <feather
              type="chevron-right"
              size="20px"
            />
          </div>
        </a>
      </div>
    </transition>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
  name: 'NewRequestPopupContent',
  data() {
    return {
      createRequestStep: 'main',

      requestCreate: {
        'LGI': ['PROCUREMENT', 'SUPPLIER'],
        'CSI': ['PROCUREMENT', 'SUPPLIER'],
        'WHI': ['PROCUREMENT', 'SUPPLIER'],
        'LOG': ['PROCUREMENT', 'SUPPLIER'],
        'RFI': ['PROCUREMENT', 'SUPPLIER', 'LOGISTIC'],
        'TRS': ['PROCUREMENT', 'LOGISTIC'],
        'RFQ': ['PROCUREMENT'],
        'PQT': ['PROCUREMENT'],
        'REV': ['PROCUREMENT'],
        'OFR': ['SUPPLIER', 'LOGISTIC'],
        'AUC': ['SUPPLIER'],
        'TRK': ['TRUCK'],
        'POL': ['PROCUREMENT', 'SUPPLIER', 'LOGISTIC'],
      }
    }
  },

  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
    }),
  },
  methods: {

    showProfileRequiredModal(requestType) {
      this.$emit('needOtherProfile', this.requestCreate[requestType]);
    },
    canCreate(requestType) {

      if(!this.profile) return false;

      switch (requestType) {
        case 'LGI':
        case 'CSI':
        case 'WHI':
        case 'LOG':
          return ['PROCUREMENT', 'SUPPLIER'].indexOf(this.profile) > -1;
        case 'RFI':
          return ['PROCUREMENT', 'SUPPLIER', 'LOGISTIC'].indexOf(this.profile) > -1;
        case 'TRS':
          return ['PROCUREMENT', 'LOGISTIC'].indexOf(this.profile) > -1;
        case 'RFQ':
        case 'REV':
          return this.profile === "PROCUREMENT";
        case 'OFR':
          return ['SUPPLIER', 'LOGISTIC'].indexOf(this.profile) > -1;
        case 'AUC':
          return ['SUPPLIER'].indexOf(this.profile) > -1;
        case 'TRK':
          return this.profile === "TRUCK";
        case 'POL':
          return this.profile !== "TRUCK";
        default:
          return false;
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.request-popup-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 1rem;
  background-color: transparent;
  border-radius: 12px;
}

.cursor-enabled {
  cursor: pointer;
}

.cursor-disabled {
  cursor: not-allowed;
}

.list-group {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin: 0.5rem 0;
  transition: all 0.3s ease;
}

.list-group-flush {
  padding: 0.5rem;
}

.list-group-item {
  color: #233656;
  font-size: 15px;
  padding: 0.8rem 1rem;
  margin-bottom: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 8px !important;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 40px;
    height: 40px;
    background-color: rgba(32, 98, 251, 0.05);
    border-radius: 50%;
    margin-right: 12px;
    transition: all 0.2s ease;
  }

  .chevron-container {
    color: #2062FB;
    opacity: 0.7;
    transition: all 0.2s ease;
  }

  &:last-child {
    margin-bottom: 0;
  }

  .request-icon {
    margin-top: 5px;
    margin-left: 10px;
    height: 32px;
    width: 32px;
    transition: transform 0.2s ease;
  }

  .request-icon-disabled {
    margin-top: 5px;
    margin-left: 10px;
    height: 32px;
    width: 32px;
    padding: 3px;
    opacity: 0.6;
  }

  &:hover {
    background-color: rgba(#2062FB, 0.08);
    border-color: rgba(#2062FB, 0.2);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(32, 98, 251, 0.1);

    .request-icon {
      transform: scale(1.1);
    }

    .icon-container {
      background-color: rgba(32, 98, 251, 0.15);
    }

    .chevron-container {
      opacity: 1;
      transform: translateX(3px);
    }
  }

  &.text-dark {
    font-weight: 500;
  }

  &.text-secondary {
    opacity: 0.7;
  }

  // Back button styling
  &.d-flex.align-items-center.cursor-enabled {
    background-color: #f8f9fa;

    svg {
      margin-right: 8px;
    }

    &:hover {
      background-color: #f0f2f5;
    }
  }
}

// Add transitions for step changes
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
